import { getGlobals } from './global-variables';

// getGlobals() is dependendent on the str-global-variables module which is dependent
// on req.settings.environment, middleware/settings.js and the JSON config files.
export default {
    isProd: () => getGlobals().environment === 'production',
    isPreProd: () => getGlobals().environment === 'pre-production'
};
